import { CurrencyTotal } from "../api/client";

export function formatMoney(cents: number, currency: string | null): string {
  const value = cents / 100;
  if (!currency) return `${value.toFixed(2)} (no currency)`;
  try {
    return new Intl.NumberFormat(undefined, { style: "currency", currency }).format(value);
  } catch {
    return `${value.toFixed(2)} ${currency}`;
  }
}

/** Sum per currency. Amounts in different currencies are never added together. */
export function addTotals(lists: CurrencyTotal[][]): CurrencyTotal[] {
  const sums = new Map<string | null, number>();
  for (const t of lists.flat()) sums.set(t.currency, (sums.get(t.currency) ?? 0) + t.total_cents);
  return [...sums].map(([currency, total_cents]) => ({ currency, total_cents })).sort((a, b) => b.total_cents - a.total_cents);
}

/** One line per currency, largest first. */
export default function MoneyTotals({ totals }: { totals: CurrencyTotal[] }) {
  if (totals.length === 0) return <>—</>;
  return (
    <span className="money-totals">
      {totals.map((t) => (
        <span key={t.currency ?? ""}>{formatMoney(t.total_cents, t.currency)}</span>
      ))}
    </span>
  );
}
